export default {
    common:{
        english: 'अंग्रेज़ी',
        india: 'भारत',
        unit: 'INR',
        nodata: 'कोई डेटा उपलब्ध नहीं है',
        save: "सहेजें",
        all: 'सभी',
        repulling:"ड्रॉपडाउन प्रक्रिया की त्वरित प्रतिलिपि",
        reloosing:"रिलीज़ प्रक्रिया संकेत प्रतिलिपि",
        reloading:"लोडिंग संकेत प्रतिलिपि",
        resuccess:"ताज़ा करना संकेत प्रतिलिपि सफलतापूर्वक",
    },
    footer:{
        home:'होम',
        gallery: 'छवि गैलरी',
        match: 'मैच',
        verification:'सत्यापन',
        mine: 'मेरा'
    },
    match:{
        title: 'सर्वश्रेष्ठ रात'
    },
    login:{
        register:'पंजीकरण करवाना',
        nameple: 'कृपया अपना उपयोगकर्ता नाम दर्ज करें',
        phoneple: 'कृपया अपना फ़ोन नंबर डालें',
        pwdple: 'कृपया पासवर्ड दर्ज करें',
        agepwdple: 'पासवर्ड फिर से दर्ज करें',
        codeple: 'कृपया आमंत्रण कोड दर्ज करें',
        agree: 'उपयोग की शर्तों से सहमत',
        tips: 'क्या आपके पास खाता है? अभी सदस्य के रूप में पंजीकरण करें।',
        login: 'लॉग इन करें'
    },
    mine:{
        creditscore:'क्रेडिट स्कोर',
        points: 'संचित अंक',
        recharge: 'रिचार्ज',
        withdraw: 'निकासी',
        available: 'उपलब्ध शेष',
        frozen: 'जमा शेष',
        information:'आवश्यक जानकारी',
        pointshistory: 'अंक इतिहास',
        withdrawdetails: 'निकासी विवरण',
        giftrecord: 'उपहार रिकॉर्ड',
        matters: 'घोषणा मामले',
        watch: 'देखने का इतिहास',
        loginpwd: 'लॉगिन पासवर्ड',
        usrpwd: 'पासवर्ड का प्रयोग करें',
        mybank: 'मेरा बैंक',
        cancellation: 'रद्द करना'
    },
    recharge:{
        point: 'एक बिंदु होना',
        remark: 'यदि आप ऑफ़लाइन चार्जिंग चाहते हैं, तो कृपया ग्राहक सेवा से सलाह लें। कुछ निपटान चैनलों की रिचार्ज राशि बेतरतीब ढंग से एक दशमलव स्थान पर रिचार्ज की जाएगी। कृपया निपटान के दौरान अवश्य पुष्टि करें',
        toserve: 'कृपया ग्राहक सेवा से संपर्क करें'
    },
    service:{
        title: 'ऑनलाइन सेवा',
        name: 'ड्रीम किंगडम क्लब',
        link: 'संपर्क करें',
        tip: 'हम आपकी सेवा के लिए 24/7 समर्पित हैं',
    },
    infomation:{
        memberid: 'सदस्य आईडी',
        fullname: 'पूरा नाम',
        bank: 'बैंक खाता विवरण',
        phone: 'फ़ोन नंबर',
        newphone: 'नया फ़ोन नंबर',
        phone_place: 'कृपया नया फ़ोन नंबर दर्ज करें',
        setname: 'वास्तविक नाम बदलें',
        name: 'नाम',
        name_place: "कृपया अपना वास्तविक नाम दर्ज करें",
        name_tip: "आपके खाते की सुरक्षा के लिए, वास्तविक नाम बाउंड बैंक कार्ड के नाम के समान होना चाहिए",
        
    },
    bank:{
        title: 'बैंक खाता विवरण',
        pushbtn: 'अपना बैंक खाता विवरण जोड़ें',
        bankname: 'बैंक का नाम',
        banknameple: 'कृपया बैंक का नाम दर्ज करें',
        pername: "प्राप्तकर्ता का नाम",
        pernameple: 'कृपया पूरा नाम दर्ज करें',
        accountNo: 'खाता संख्या',
        accountNople: 'कृपया खाता संख्या दर्ज करें',
        ifsc: 'IFSC',
        ifscple: 'कृपया IFSC कोड दर्ज करें',
        pwd: 'निकासी पासवर्ड',
        pwdple: 'कृपया निकासी पासवर्ड दर्ज करें',
        btn: 'बैंक खाता विवरण'
    },
    index: {
        girl: 'लोकप्रियता अनुशंसा सूची',
        advanced:'उन्नत',
        certification: 'साइट प्रमाणन',
        authentication: 'मेरा अपना वीडियो प्रमाणीकरण',
        rating: 'रेटिंग',
        apply: 'एक तारीख के लिए आवेदन करें',
        accounttitle: 'रीयल टाइम स्थिति',
        accountmsg: '{name} सदस्य के रूप में शामिल हुए'
    },
    verification:{
        title:'सत्यापन',
        benefit:'वीआईपी लाभ'
    },
    profile:{
        profile:'लड़कियों की प्रोफ़ाइल',
        click: 'प्रमाणीकरण पर क्लिक करें'
    },
    reservation: {
        bearer:'स्टैंडर्ड-बियरर',
        data:'डेटा',
        time: 'शेष समय',
        round: 'राउंड',
        quantity: 'मात्रा',
        poinnts: 'उपलब्ध अंक',
        morepro: 'अधिक उत्पाद',
        itemerror: 'आप अधिकतम 2 आइटम चुन सकते हैं',
        "hall": "आरक्षण हॉल",
        "refresh": "सफलतापूर्वक ताज़ा करें",
        "money_err": "गलत राशि",
        "choose_num": "कृपया एक आइटम चुनें!",
        "balance_enough": "अपर्याप्त शेष, कृपया रिचार्ज करने के लिए ग्राहक सेवा से संपर्क करें!",
        "contact_admin": "कृपया इस कार्य के लिए व्यवस्थापक से संपर्क करें!",
        "prize_succ": "लॉटरी ड्रॉ सफल रहा, अंक संख्या:",
        "task_list": "मिशन सूची",
        "available_balance": "उपलब्ध शेष",
        "counselor": "कृपया किसी सलाहकार या रिसेप्शनिस्ट से संपर्क करें",
        "clear_order": "ऑर्डर साफ़ करें",
        "submit": "पुष्टि करें",
        "num": "अंक",
        "win_num": "जीतने वाले नंबर",
        "curr_choose": "वर्तमान चयन",
        "per_price": "प्रति दांव राशि",
        "price_place": "कृपया राशि दर्ज करें",
        "unit": "टिकट",
        "total": "कुल",
        "note": "ध्यान दें",
        "money": "दांव राशि",
        "order_time": "आदेश समय",
        "settle_time": "निपटान समय",
        "no_choose": "अचयनित",
        "big": "A",
        "small": "B",
        "double": "D",
        "single": "C",
        "win_formula": "लाभ गणना सूत्र: जीत राशि - कार्य राशि"
    },
    "video": {
        "video": "वीडियो थिएटर",
        "play": "चलाएँ",
        "no_more": "और नहीं",
        "num_play": "बजाता है",
        "account_out": "खाता ऑफ़लाइन",
        "buy": "कृपया रिचार्ज करें और वीडियो देखें",
        "recmonmand": "लोकप्रिय सिफारिश",
        welcome: 'नमस्ते,{name}',
        tickets: 'अधिक मूवी टिकट प्राप्त करने के लिए कार्य पूरा करें',
        num:'मूवी रील',
        title:'वॉच लिस्ट'
    },
    "withdraw": {
        "with_center": "निकासी",
        "with_record": "विवरण",
        "with_money": "निकासी राशि",
        "recharge_money": "रिचार्ज राशि",
        "task_money": "कार्य राशि",
        "win_money": "जीत राशि",
        "single_limit": "एकल सीमा",
        "low": "सबसे कम",
        "heigh": "उच्चतम",
        "with_num": "निकासी की संख्या: एक दिन में अधिकतम निकासी",
        "number": "द्वितीय श्रेणी",
        "with_tip": "आगमन समय: आम तौर पर, आगमन का समय लगभग 5 मिनट है, और सबसे तेज़ आगमन समय 2 मिनट है।",
        "limit_desc": "सीमा विवरण",
        "immediately_withdraw": "तुरंत निकासी करें",
        "empty_data": "डेटा खाली है",
        "money": "राशि",
        "desc": "समझाना",
        "submit_time": "प्रस्तुति समय",
        "check_time": "समीक्षा समय",
        "with_service": "निकासी पासवर्ड सेट किया गया है। यदि आपको इसे संशोधित करने की आवश्यकता है, तो कृपया ग्राहक सेवा से संपर्क करें।"
    },
    "setting": {
        "setting": "सेट अप",
        "base_setting": "मूल जानकारी",
        "login_pwd": "लॉगिन पासवर्ड",
        "finance_pwd": "फंड पासवर्ड",
        "language": "भाषा चयन",
        "logout": "साइन आउट",
        "avatar": "अवतार",
        "choose_avatar": "अवतार चुनें",
        "ok": "ज़रूर",
        "cancel": "रद्द करें",
        "real_name": "वास्तविक नाम",
        "modify_real_name": "वास्तविक नाम संपादित करें",
        "name_place": "कृपया अपना वास्तविक नाम दर्ज करें",
        "save": "सहेजें",
        "name": "नाम",
        "name_tip": "आपके खाते की सुरक्षा के लिए, वास्तविक नाम बाउंड बैंक कार्ड के नाम के समान होना चाहिए",
        "repect": "सेटिंग्स दोहराएं नहीं!",
        "sex": "लिंग",
        "sex_place": "लिंग संशोधन",
        "man": "पुरुष",
        "female": "महिला",
        "unkown": "अनजान",
        "no_setting": "सेट नहीं है",
        "y_setting": "सेट किया गया है",
        "bindinged": "बाउंड",
        "no": "कोई नहीं",
        "login_pwd_tip": "लॉगिन पासवर्ड संशोधित करें",
        "old_pwd": "पुराना पासवर्ड",
        "new_pwd": "नया पासवर्ड",
        "old_pwd_tip": "कृपया अपना पुराना पासवर्ड दर्ज करें",
        "new_pwd_tip": "कृपया अपना नया पासवर्ड दर्ज करें",
        "new_again_tip": "कृपया अपना नया पासवर्ड फिर से दर्ज करें",
        "prefect": "कृपया पूरी तरह से भरें!",
        "pwd_error": "दो बार दर्ज किया गया पासवर्ड असंगत है",
        "set_money_pwd": "फंड पासवर्ड सेट करें",
        "money_place": "कृपया फंड पासवर्ड दर्ज करें",
        "money_again_place": "कृपया फंड पासवर्ड फिर से दर्ज करें",
        "correct_money": "कृपया सही राशि भरें",
        "contact_recharge": "कृपया रिचार्ज करने के लिए ग्राहक सेवा से संपर्क करें",
        "set_bank": "कृपया एक भुगतान कार्ड सेट करें",
        "forbid": "फीचर अक्षम",
        "log_reg": "लॉग इन रजिस्टर",
        "more_service": "अधिक सेवाओं का आनंद लेने के लिए साइन इन करें!",
        "bind_bank_info": "बैंक कार्ड जानकारी बांधें",
        "bank_info": "बैंक कार्ड जानकारी",
        "add_bank": "एक बैंक कार्ड जोड़ें",
        "bind_bank_tip": "टिप: कृपया एक बड़ा वाणिज्यिक बैंक बांधें, यदि आपको संशोधित करने की आवश्यकता है, तो कृपया ऑनलाइन ग्राहक सेवा से संपर्क करें",
        "fill_bank": "भुगतान कार्ड भरें",
        "fill_bank_tip": "कृपया अपनी भुगतान कार्ड जानकारी दर्ज करें",
        "band_account": "बैंक कार्ड नंबर",
        "set_name_bank": "बैंक कार्ड बांधने से पहले कृपया अपना नाम सेट करें!",
        "set_pwd_bank": "बैंक कार्ड बांधने से पहले कृपया निकासी पासवर्ड सेट करें!",
        "band_name": "बैंक का नाम",
        "band_account_tip": "कृपया वास्तविक बैंक कार्ड नंबर दर्ज करें",
        "band_name_tip": "कृपया एक बैंक चुनें",
        "bank_warn": "प्रिय उपयोगकर्ताओं, आपके फंड की सुरक्षा सुनिश्चित करने के लिए, कृपया अपना वास्तविक नाम बांधें और एक निकासी पासवर्ड सेट करें। यदि नाम खाता नाम के साथ असंगत है, तो आप पैसे नहीं निकाल पाएंगे",
        "bank_ok": "कार्ड बांधना सुनिश्चित करें",
        "username":"नाम",
        "username_place":"कृपया अपना वास्तविक नाम दर्ज करें",
        "mobile":"फ़ोन नंबर",
        "mobile_place":"कृपया अपना फ़ोन नंबर टाइप करें"
    }
}
